import TranslationHelper from '@/helpers/translation';
import i18n from '@/i18n';

export default {
	install: (Vue, options) => {
		Vue.prototype.$translate = {
			action_and_note: function(actionAndNote) {
				return TranslationHelper.action_and_note(i18n, actionAndNote);
			},
			action_message_code: function(actionMessageCode) {
				return TranslationHelper.action_message_code(i18n, actionMessageCode);
			},
			action_status: function(actionStatus) {
				return TranslationHelper.action_status(i18n, actionStatus);
			},
			channel: function(channel) {
				return TranslationHelper.channel(i18n, channel);
			},
			dispute_code: function(dispute_code) {
				return TranslationHelper.dispute_code(i18n, dispute_code);
			},
			iso_country_code: function(isoCountryCode) {
				return TranslationHelper.iso_country_code(i18n, isoCountryCode);
			},
			invoice_status: function(invoiceStatus) {
				return TranslationHelper.invoice_status(i18n, invoiceStatus);
			},
			language: function(language) {
				return TranslationHelper.language(i18n, language);
			},
			legal_id_type: function(legalIdType) {
				return TranslationHelper.legal_id_type(i18n, legalIdType);
			},
			legal_id_type_description: function(legalIdTypeDescription) {
				return TranslationHelper.legal_id_type_description(i18n, legalIdTypeDescription);
			},
			payment_reference_type: function(paymentReferenceType) {
				return TranslationHelper.payment_reference_type(i18n, paymentReferenceType);
			},
			payment_plan_status: function(status) {
				return TranslationHelper.payment_plan_status(i18n, status);
			},
			period: function(period) {
				return TranslationHelper.period(i18n, period);
			},
			template_id: function(templateId) {
				return TranslationHelper.template_id(i18n, templateId);
			},
			tag: function(tag) {
				return TranslationHelper.tag(i18n, tag);
			},
			tone_of_voice: function(tone_of_voice) {
				return TranslationHelper.tone_of_voice(i18n, tone_of_voice);
			},
			document_type: function(documentType) {
				return TranslationHelper.document_type(i18n, documentType);
			}
		};
	}
};
